import styled from "styled-components";
import { colors } from "../../../../../../theme/theme";

export const CardButton = styled.div`
    text-align: right;
    button { 
        color: ${colors.greyscale.white};
        background-color: transparent;
        border: 0px;
    }
`;

export const CardUnity = styled.div`
    background-color: ${colors.mainColors.white_lilac};
    padding: 7px 10px;
    color: ${colors.mainColors.blueberry};
    border-radius: 4px;
    border-left: 10px solid ${colors.mainColors.verde_dstore};

    button { 
        color: ${colors.mainColors.blueberry};
    }
`

